'use client'
import { useSidebar } from '@/hooks/useSidebar'
import React from 'react'

const BarsButton = () => {
  const { isOpen, toggleSidebar } = useSidebar()
  return (
    <>
      <button
        aria-label="barsbutton"
        className="xl:hidden p-3 rounded-lg bg-primary flex flex-col items-center gap-1"
        onClick={toggleSidebar}
      >
        <span
          className={`block w-6 h-0.5 bg-white transition-all duration-300 ${
            isOpen ? 'rotate-45 translate-y-1' : ''
          }`}
        ></span>
        <span
          className={`block w-6 h-0.5 bg-white transition-all duration-300 ${
            isOpen ? 'opacity-0' : ''
          }`}
        ></span>
        <span
          className={`block w-6 h-0.5 bg-white transition-all duration-300 ${
            isOpen ? '-rotate-45 -translate-y-1' : ''
          }`}
        ></span>
      </button>
    </>
  )
}

export default BarsButton
